import React from 'react';
import { withRouter } from 'react-router-dom';
import Game from './game/Game';
import Lobby from './Lobby';
import Error from './Error';
import './Room.scss';
import { joinRoom, isJoiningRoom, hasLoadedRoom, hasGameStarted } from '../redux/gameSlice';
import { useDispatch, useSelector } from 'react-redux';
import { Trans, t } from '@lingui/macro';
import i18n from "../i18n";

function Room(props) {
  const dispatch = useDispatch();
  const isJoining = useSelector(isJoiningRoom);
  const hasLoaded = useSelector(hasLoadedRoom);
  const roomId = useSelector(state => state.game.roomId);
  const roomError = useSelector(state => state.game.roomError);
  const gameStarted = useSelector(hasGameStarted);

  if (!isJoining && !roomId && !roomError) {
    // If the user isn't joining and there's no room ID, good chance
    // we loaded the URL directly and have to join the room based on the URL
    let newRoomId = props.match.params.id ? props.match.params.id.toUpperCase() : "";
    if (newRoomId && newRoomId.length !== 6) {
      console.error("Invalid room ID! Going back to landing");
      props.history.push("/");
      return null;
    }

    dispatch(joinRoom(newRoomId));
  }

  if (!hasLoaded) {
    if (!roomError) {
      return <div id="content">
        <div id="joining">
          <i className="fas fa-spinner"></i><span className="loading-text"><Trans>Connecting to server...</Trans></span>
        </div>
      </div>
    } else {
      const action = {
        link: '/',
        text: <Trans>GO TO HOMEPAGE</Trans>
      };

      let roomErrorHuman = "";
      const [roomErrorId, args] = roomError.split("|");
      switch (roomErrorId) {
        case "ROOM_DOESNT_EXIST":
          if (!args) {
            roomErrorHuman = t`Room doesn't exist!`;
          } else {
            roomErrorHuman = t`Room ${args} doesn't exist!`;
          }
          break;

        case "ROOM_ALREADY_FULL":
          roomErrorHuman = t`Room is already full!`;
          break;

        case "GAME_ALREADY_STARTED":
          roomErrorHuman = t`Game already started!`;
          break;

        case "GAME_ROOM_CLOSED_BY_OWNER":
          roomErrorHuman = t`This game room has been closed by its owner`;
          break;

        case "GAME_ROOM_CLOSED_BY_SERVER":
          roomErrorHuman = t`This game room has been automatically closed by the server. This will normally happen if there was no activity for a long period of time, the game already ended, or the game had been running for too long.`;
          break;

        case "INVALID_ROOM_ID":
          roomErrorHuman = t`This room ID isn't valid`;
          break;

        case "KICKED_FROM_ROOM":
          roomErrorHuman = t`You've been kicked out of this game room`;
          break;

        default:
          roomErrorHuman = t`An unknown error happened while joining this room`;
          break;
      }

      return <Error title={<Trans>FAILED TO JOIN GAME</Trans>} message={i18n._(roomErrorHuman)} action={action} />
    }
  }

  // Lobby
  if (!gameStarted) {
    return <Lobby />;
  }

  return <Game />;
}

export default withRouter(Room);
